export default {
  QuoteSmsIncoming: 1,
  QuoteEmailIncoming: 2,
  CompanyLicense: 3,
  QuoteWhatsAppIncoming: 4,
  CustomerUploaded: 5
}